<template>
  <div class="member-discounts bg-background-light pt-6 px-6 pb-12 md:pt-16 md:px-8 md:pb-20 text-left tracking-0.15px ">
    <h6 class="text-lg md:text-2xl text-black-high-emphasis mb-2 md:mb-8">
      {{ content.title }}
    </h6>
    <div v-dompurify-html="content.discounts" class="richtext"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { MemberDiscounts } from '@/model'

export default defineComponent({
  props: {
    content: {
      type: MemberDiscounts,
      required: true,
      validator: (value: MemberDiscounts) => value instanceof MemberDiscounts
    }
  }
})
</script>
